<template>
  <div class="d-flex-column">
    <div v-if="isError === true">
      <h1 class="my-2 text-error">Lỗi dữ liệu</h1>
      <p>
        Vui lòng kiểm tra lại dữ liệu của dòng <span class="text-error">{{ getIndexError(indexError) }}</span
        ><span v-if="indexError.length > 3"> và <span class="text-error">các dòng khác</span></span
        >.
      </p>
    </div>
    <div :class="alignClass">
      <v-btn color="primary" class="mr-3 text-none" @click="exportTemplate" outlined>Tải mẫu nhập</v-btn>
      <v-btn color="primary" class="elevation-0 text-none" :loading="isSelecting" @click="onUpload">
        <div class="white--text">Chọn tệp</div>
        <input
          ref="uploader"
          type="file"
          class="d-none"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx"
          @change="onFileChanged"
        />
      </v-btn>
    </div>
  </div>
</template>
<script>
import utils from '@/plugins/utils'
import readXlsxFile from 'read-excel-file'
import get from 'lodash-es/get'
const xlsxFileSchema = {
  'Tên giáo viên': {
    prop: 'name',
    type: String
  },
  'Mã số': {
    prop: 'code',
    type: String
  }
}
export default {
  props: {
    alignClass: String
  },
  data() {
    return {
      isSelecting: false,
      selectedFile: null,
      isError: false,
      indexError: [],
      step: 'import'
    }
  },
  methods: {
    exportTemplate() {
      this.$loading.active = true
      utils.exportExcel(
        [{ name: 'Nguyễn Văn Công', code: 'congnv' }],
        [
          { text: 'Tên giáo viên', value: 'name' },
          { text: 'Mã số', value: 'code' }
        ],
        'Mẫu nhập danh sách giáo viên kèm mã số'
      )
      this.$loading.active = false
    },
    onUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, { schema: xlsxFileSchema })
      } catch (error) {
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.step = 'upload'
        let data = this.validateData(results)
        this.isError = data.isError
        this.indexError = data.indexError
        if (!data.isError) this.$emit('onDataImported', data.results)
      }
      this.$loading.active = false
    },
    validateData(results = []) {
      let isError = false
      const indexError = []
      for (let i = 0; i < results.length; i++) {
        results[i].index = i + 1
        if (results[i].code === undefined || get(results[i], 'code.length', 0) !== 5) {
          indexError.push(i + 1)
          results[i].code = 'Thiếu thông tin'
          isError = true
        }
      }
      return { indexError, results, isError }
    },
    getIndexError(indexError) {
      if (indexError.length >= 3) {
        return `${indexError[0]}, ${indexError[1]}, ${indexError[2]}`
      } else if (indexError.length >= 2) {
        return `${indexError[0]}, ${indexError[1]}`
      } else {
        return `${indexError[0]}`
      }
    }
  }
}
</script>
